import React, { useContext } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { InputContext } from '../chat-input';

const InputAttach = () => {
    const inputHook = useContext(InputContext);
    const { editingMessage, onAttach, onCancelEdit, isSending } = inputHook!;

    return (
        <>
            <Tooltip title="پیوست فایل" arrow>
                <span>
                    <IconButton
                        disabled={isSending}
                        onClick={onAttach}
                        sx={{ width: 40, height: 40, color: 'text.secondary', '&:hover': { color: 'primary.main', bgcolor: 'action.hover' } }}>
                        <i className="fa-light fa-paperclip" style={{ fontSize: 17 }} />
                    </IconButton>
                </span>
            </Tooltip>

            {editingMessage && (
                <Tooltip title="لغو ویرایش" arrow>
                    <IconButton
                        onClick={onCancelEdit}
                        sx={{ width: 40, height: 40, color: 'text.secondary' }}>
                        <i className="fa-light fa-xmark" style={{ fontSize: 16 }} />
                    </IconButton>
                </Tooltip>
            )}
        </>
    );
};

export default InputAttach;
